import React from 'react';

export const FIELDSET_TITLE = 'Leave Your Next Project To Us';

export const samHowToBuyCarpetSteps = [
  /* eslint-disable */
  {
    title: 'Choose your carpet and estimate project costs',
    content: 'Select from a wide assortment of carpet to fit your room, lifestyle and budget. Order samples online or visit your local Home Depot store to view carpet samples. Enter your room measurements and product selection to get an idea of the cost of your carpet installation.'
  },
  {
    title: 'Checkout online or schedule an in-home measure',
    content: (<>After you complete your estimate, you will have the option to checkout online and then, when it is convenient to you, we'll send a certified technician to your home to confirm precise digital measurements and note special instructions. <br /> <br /> We also offer the ability to schedule your professional in home measure before proceeding with your order if that is preferred.</>),
  },
  {
    title: 'We\'ll install it for you',
    content: 'Our local, licensed installers will take care of everything to get your new carpet installed, including disposing of your old carpet. We\'ll provide a final project quote and review financing options with you.'
  }
    /* eslint-enable */
];